import { type FC } from "react";
import { Button } from "../../../primitives/Button";
import { Icon } from "../../../primitives/Icon";
import { Text } from "../../../primitives/Text";

type OutcomeStepProps = {
	outcome: "approved" | "review";
	onViewDetails: () => void;
};

export const OutcomeStep: FC<OutcomeStepProps> = ({ outcome, onViewDetails }) => {
	const title =
		outcome === "approved"
			? "Bond Request Approved"
			: "An underwriter is reviewing your bond request";

	const subtitle =
		outcome === "approved"
			? "Click below to review and accept the terms."
			: "Click below to confirm extracted details and provide any missing information.";

	return (
		<div
			className="flex flex-col items-center gap-6 px-6 py-8 text-center"
			data-testid="outcome-step"
			data-outcome={outcome}
		>
			<div className="flex flex-col gap-6">
				<div className="flex items-center justify-center gap-3">
					{outcome === "approved" ? (
						<Icon type="check-circle" color="confirm" size="medium" />
					) : (
						<Icon type="headset" color="tertiary" size="medium" />
					)}
					<Text type="title">{title}</Text>
				</div>
				<Text type="body">{subtitle}</Text>
			</div>
			<Button
				color="primary"
				onClick={onViewDetails}
				data-testid="view-details-btn"
				trackingId="bond-request-modal-outcome-view-details"
			>
				View Bond Request
			</Button>
		</div>
	);
};
